import * as Yup from "yup";

export const validationSchema = Yup.object({
    title: Yup.string()
        .required("Title is required")
        .max(255, "Title cannot exceed 255 characters")
        .trim(),
    message: Yup.string()
        .required("Message is required")
        .max(1000, "Message cannot exceed 1,000 characters")
        .trim(),
    scheduleDate: Yup.string().required("Schedule date is required"),
    scheduleTime: Yup.string().required("Schedule time is required"),
});
